import { NavigationGuardNext, Route } from 'vue-router';

import { LIST_ONBOARDING_ID } from '@/constant/OnboardingIDS';
import { IDS_FOR_PERMISSION_COURSE } from '@/constant/CoursesId';

import Onboarding from '@/share/Util/Onboarding/Onboarding';

import Permission from '../permission/index';

const onboarding = new Onboarding();

export function onboardingCourse(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const idCourses = to.params?.idCourses;

  const hasPermission = idCourses
    ? PermissionClass.can(IDS_FOR_PERMISSION_COURSE[Number(idCourses)])
    : Object.values(IDS_FOR_PERMISSION_COURSE).some((permission: string) => PermissionClass.can(permission));

  if (onboarding.alreadyViewedOnboarding(LIST_ONBOARDING_ID.COURSE) || !hasPermission) {
    return next();
  }

  return next();
}

export function onboardingQuestions(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  if (to.query && to.query.isFree) {
    return next();
  }

  if (onboarding.alreadyViewedOnboarding(LIST_ONBOARDING_ID.EXERCISES)) {
    return next();
  }

  return next({
    name: 'TutorialQuestions'
  });
}

export function onboardingBooks(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  return next();
}

export function onboardingVideos(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  if (onboarding.alreadyViewedOnboarding(LIST_ONBOARDING_ID.BOOKS_VIDEOS)) {
    return next();
  }

  return next({
    name: 'TutorialVideos',
    params: {
      context: `${to.params?.context || ''}`,
      path: `${to.params?.path || ''}`,
      topicID: `${to.params?.topicID || ''}`,
      fileID: `${to.params?.fileID || ''}`,
      slugFile: `${to.params?.slugFile || ''}`
    }
  });
}

export function onboardingExercise(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  if (onboarding.alreadyViewedOnboarding(LIST_ONBOARDING_ID.BOOKS_EXERCISES)) {
    return next();
  }

  return next({
    name: 'TutorialExercise',
    params: {
      context: `${to.params?.context || ''}`,
      path: `${to.params?.path || ''}`,
      topicID: `${to.params?.topicID || ''}`,
      fileID: `${to.params?.fileID || ''}`,
      slugFile: `${to.params?.slugFile || ''}`
    }
  });
}

export function onboardingCalendar(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  return next();
}

export function onboardingClasses(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  if (to.query && to.query.isFree) {
    return next();
  }

  if (onboarding.alreadyViewedOnboarding(LIST_ONBOARDING_ID.CLASSES)) {
    return next();
  }

  return next({
    name: 'TutorialClasses'
  });
}

export function onboardingWar(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  return next();
}
